import { IComponentOptions, IController, IFormController } from 'angular';
import { PasswordService } from '../../../../core/services/password/password.service';
import { TransitionBarService } from '../../../../ui/transition-bar/transition-bar.service';
import './password-recovery.component.scss';

class PasswordRecoveryController implements IController {
  static $inject = [
    'PasswordService',
    'TransitionBarService'
  ];
  email: string;
  form: IFormController;
  successMessage: string;
  serverError: string;
  loading = false;

  constructor( private passwordService: PasswordService,
               private transitionBarService: TransitionBarService ) {
  }

  submit() {
    if ( this.form.$valid ) {
      this.loading = true;
      this.serverError = '';
      this.transitionBarService.barActive(true);
      this.passwordService.resetPassword(this.email)
        .then(( res ) => {
          console.log(res);
          this.successMessage = 'The password was sent to your e-mail.';
        })
        .catch(( err ) => {
          console.log(err);
          if ( err.data && err.data.text ) {
            this.serverError = err.data.text;
          } else {
            this.serverError = err.message || 'Error';
          }
        })
        .finally(() => {
          this.transitionBarService.barActive(false);
          this.loading = false;
        });
    }
  }
}

export const PasswordRecoveryComponent: IComponentOptions = {
  controller: PasswordRecoveryController,
  template: require('./password-recovery.component.html')
};



// WEBPACK FOOTER //
// ./app/states/auth/components/password-recovery/password-recovery.component.ts